export const accountIdentity = {
  type: "string",
  minLength: 1,
  maxLength: 255,
  transform: ["trim", "toLowerCase"]
};
